<template>
  <header
    class="page-header"
  >
    <div class="page-header__inner">
      <button
        type="button"
        @click="goBack()"
        class="back_btn"
      >
        <component
          :is="'chevron-left'"
          class="page-header__icon page-header__icon--left"
        />
      </button>
      <p class="caps">
        {{ pageTitle }}
      </p>
      <Chat type="small" />
    </div>
  </header>
</template>

<script>
import * as components from '@/icons'
import Chat from '@/components/partials/Chat'

export default {
  components: {
    ...components,
    Chat
  },
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    hasHistory () {
      return window.history.length > 2
    },
    goBack () {
      if (!this.hasHistory()) {
        this.$router.replace('/')
        return true
      }
      try {
        this.$router.back()
      } catch (e) {
        this.$router.push('/')
      }
      return false
    }
  }
}
</script>

<style lang="scss">
  .page-header {
    --safe-area-inset-top: env(safe-area-inset-top);
    --safe-area-inset-top: const(safe-area-inset-top);
    height: $page-header-height;
    &__inner {
      position: fixed;
      top: 0;
      // left: 0;
      z-index: 10;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      max-width: 600px;
      margin: auto;
      background: $page-header-background;
      color: $page-header-color;
      padding: $page-header-padding;
      .caps {
        padding: 0 1rem;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      // padding-top: calc(#{$page-header-padding-top} + var(--safe-area-inset-top)); // Need to test this
    }
    button {
      padding: 0;
    }
    svg {
      fill: currentColor;
      height: $page-header-icon-size;
    }
  }

  .back_btn {
    width: 40px;
    height: 40px;
    display: block;
    margin-left: -10px;
    margin-top: -10px;
    margin-bottom: -10px;
    z-index: 30;
  }
</style>

<docs>
  ```vue
    <PageHeader page-title="page title" />
  ```
  ```scss
  // Variable defaults:
  $page-header-height: rem(41);
  $page-header-background: color(dark);
  $page-header-color: color(light);
  $page-header-padding: rem(10 16);
  $page-header-icon-size: rem(18);
  ```
</docs>
